import { useEffect, useState } from 'react';

// Shared by all application pages, including POS. No page owns sidebar behavior.
export const MOBILE_MENU_QUERY = '(max-width: 1023px)';
export default function useSidebar(pathname) {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_MENU_QUERY).matches);
  const [navHidden, setNavHidden] = useState(() => window.matchMedia(MOBILE_MENU_QUERY).matches || pathname === '/pos');
  useEffect(() => {
    const query = window.matchMedia(MOBILE_MENU_QUERY);
    const changed = event => setIsMobile(event.matches);
    query.addEventListener('change', changed);
    return () => query.removeEventListener('change', changed);
  }, []);
  useEffect(() => { setNavHidden(isMobile || pathname === '/pos'); }, [isMobile, pathname]);
  return { isMobile, navHidden, setNavHidden };
}
